export const courseNames = [
  "F20RS",
  "F20SA",
  "F20RO",
  "F20BC",
  "F20PA",
  "F20GA",
  "F20CN",
  "F20DL",
  "F20IF",
  "F20SC",
];

export const fullnames = [
  "Rigorous Methods for Soft Eng",
  "Stat Model & Anal",
  "Intelligent Robotics",
  "Biologically Inspired Comp",
  "Res Meths & Requirements Eng",
  "3D Graphics and Animation",
  "Computer Network Security",
  "Data Mining & Machine Learning",
  "Information Sys Methodologies",
  "Industrial Programming",
];

export const info = [
  {
    title: `${courseNames[0]} - ${fullnames[0]}`,
    room: "5.33-Collaborative Lecture Theatre (33)",
    prof: "H. Zantout",
    time: "18:30 - 21:30",
    type: "Lec",
  },
  {
    title: `${courseNames[0]} - ${fullnames[0]}`,
    room: "TBC-Computer Lab",
    prof: "H. Zantout",
    time: "21:30 - 22:30",
    type: "CLab",
  },
  {
    title: `${courseNames[1]} - ${fullnames[1]}`,
    room: "5.09-Classroom (40), 5.12-Classroom (32)",
    prof: "A. Turcanu",
    time: "18:30 - 21:30",
    type: "Lec",
  },
  {
    title: `${courseNames[1]} - ${fullnames[1]}`,
    room: "5.09-Classroom (40), 5.12-Classroom (32)",
    prof: "A. Turcanu",
    time: "20:30 - 21:30",
    type: "Tut",
  },
  {
    title: `${courseNames[1]} - ${fullnames[1]}`,
    room: "Computer Laboratory (17)",
    prof: "A. Turcanu",
    time: "21:30 - 22:30",
    type: "CLab",
  },
  {
    title: `${courseNames[2]} - ${fullnames[2]}`,
    room: "4.08",
    prof: "T. Shaikh",
    time: "18:30 - 20:30",
    type: "Lec",
  },
  {
    title: `${courseNames[2]} - ${fullnames[2]}`,
    room: "4.31-Computer Laboratory (23)",
    prof: "T. Shaikh",
    time: "20:30 - 22:30",
    type: "CLab",
  },
  {
    title: `${courseNames[3]} - ${fullnames[3]}`,
    room: "2.09-Classroom (50)",
    prof: "H. Batatia",
    time: "18:30 - 21:30",
    type: "Lec",
  },
  {
    title: `${courseNames[3]} - ${fullnames[3]}`,
    room: "2.09-Classroom (50)",
    prof: "H. Batatia",
    time: "21:30 - 22:30",
    type: "Tut",
  },
  {
    title: `${courseNames[4]} - ${fullnames[4]}`,
    room: "2.09-Classroom (50)",
    prof: "Hani Ragab",
    time: "16:30 - 18:30",
    type: "Lec",
  },
  {
    title: `${courseNames[5]} - ${fullnames[5]}`,
    room: "2.09-Classroom (50)",
    prof: "Dr. R. Soobhany",
    time: "18:30 - 20:30",
    type: "Lec",
  },
  {
    title: `${courseNames[5]} - ${fullnames[5]}`,
    room: "4.31-Computer Laboratory (23)",
    prof: "Dr. R. Soobhany",
    time: "20:30 - 22:30",
    type: "CLab",
  },
  {
    title: `${courseNames[6]} - ${fullnames[6]}`,
    room: "5.09-Classroom (40)",
    prof: "Hani Ragab",
    time: "18:30 - 20:30",
    type: "Lec",
  },
  {
    title: `${courseNames[6]} - ${fullnames[6]}`,
    room: "5.35B-Computer Laboratory (23)",
    prof: "Hani Ragab",
    time: "20:30 - 22:30",
    type: "CLab",
  },
  {
    title: `${courseNames[7]} - ${fullnames[7]}`,
    room: "5.09-Classroom (40), 5.12-Classroom (32)",
    prof: "N. El Gayar",
    time: "18:30 - 20:30",
    type: "Lec",
  },
  {
    title: `${courseNames[7]} - ${fullnames[7]}`,
    room: "5.35C-Computer Laboratory (21)",
    prof: "N. El Gayar",
    time: "20:30 - 22:30",
    type: "CLab",
  },
  {
    title: `${courseNames[8]} - ${fullnames[8]}`,
    room: "6.44-Classroom (26)",
    prof: "S. Gill",
    time: "18:30 - 20:30",
    type: "Lec",
  },
  {
    title: `${courseNames[8]} - ${fullnames[8]}`,
    room: "6.44-Classroom (26)",
    prof: "S. Gill",
    time: "20:30 - 21:30",
    type: "Tut",
  },
  {
    title: `${courseNames[9]} - ${fullnames[9]}`,
    room: "5.35B-Computer Laboratory (23)",
    prof: "S. Kumar",
    time: "18:30 - 20:30",
    type: "Lec",
  },
  {
    title: `${courseNames[9]} - ${fullnames[9]}`,
    room: "5.35B-Computer Laboratory (23)",
    prof: "S. Kumar",
    time: "20:30 - 22:30",
    type: "CLab",
  },
];